

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import FoodImageModel from "@/model/FoodImageModel";

@Component({})

export default class DetailImageDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({type: Array as () => FoodImageModel[] | null}) foodImageList!: FoodImageModel[]
  @Prop({type: String , default: false }) selectedFoodName!: string
  @Prop({ type: Number, default: false }) readonly index!: null
  @Prop({type: Object as () => any}) selectedFood!: any



  private image: number | null = this.index

  get isShowArrows (): boolean {
      if(this.foodImageList && this.foodImageList.length > 1) {
          return true
      } else {
          return false
      }
  }

  getImage (item: any) {
      return `/api/food-database/food-item-media/${item.id}/data`
  }

  onCloseButtonClick (): void {
    this.$emit('close')
  }

  mounted() {
  }

}

